import { bool, func } from "prop-types";
import { useTranslation } from "react-i18next";
import {
  ValueCell,
  PinnableCell,
  SummaryRow,
} from "@tools";
import { AddButtonFull } from "@components";

export const NewRateElementRow = ({
  isWorkType, 
  onClick,
}) => {
  const { t } = useTranslation();
  
  return (
    <SummaryRow useExpandCell isLastGroupRow tableDepth={isWorkType ? 0 : 1}>
      <PinnableCell
        keepSmallestSize
        pinnedLeft
        tableDepth={isWorkType ? 0 : 1}
        allowOverflowDisplay
        innerStyle={isWorkType ? undefined : { paddingLeft: 34 }}
      >
        <AddButtonFull
          id="newTeamMemberButton-summary"
          onClick={onClick}
          name={
            isWorkType ? "Add new work type" : "Add new resource to work type"
          }
        >
          {t(`views.editor.summary_table.${isWorkType ? "work_add" : "work_resource_add"}`)}
        </AddButtonFull>
      </PinnableCell>
      <ValueCell size="small" />
      <ValueCell size="large" extendPadding />
      <ValueCell size="large" extendPadding />
      <ValueCell size="small" />
    </SummaryRow>
  );
};

NewRateElementRow.propTypes = {
  isWorkType: bool,
  onClick: func.isRequired,
}